/*
 * @Author: knight
 * @Title:  新课推荐
 * @Date: 2020-04-15 21:20:47
 * @Last Modified by: knight
 * @Last Modified time: 2020-05-27 15:37:05
 */
<template>
     <ul
        class = "block-list-content"
        >
        <li
            class = 'block-list-item'
            v-for = '(list, index) in resource' :key = 'index'>

                <div class = 'block-list-item-box'>
                    <div class = 'block-list-item-img'>
                        <a :href="`${list.link}?spm_id_from=${spmidfrom}` | hostAdapt | csourceTransmit" target="_blank"  v-href>
                            <BiliImg :src = 'list.cover' :width="376" :height='212' cut  class = 'block-list-lazyImg' />
                        </a>
                        <!-- <div class = 'block-list-item-label' v-if = 'list.status_label'>{{ list.status_label }}</div> -->

                    </div>

                    <div class = 'block-list-item-first-content'>
                        <a :href="`${list.link}?spm_id_from=${spmidfrom}` | hostAdapt | csourceTransmit" target="_blank" v-href>
                            <p class = 'block-list-item-title'>{{ list.title }}</p>
                        </a>
                        <p class = 'block-list-item-desc ell'>{{ list.subtitle }}</p>

                        <div class = 'block-list-item-playInfo-first'>
                            <span class = 'block-list-item-playInfo-first-count'>{{ list.stat && list.stat.view | isThousand }}{{ list.stat ? '播放' : '' }}</span>
                            <span class = 'block-list-item-playInfo-line'>|</span>
                            <span>{{ '共' + list.ep_count + '课时' }}</span>
                        </div>

                        <div class = 'block-list-item-price-first'>
                            <p class="block-list-item-price buy" v-if = 'list.user_status && list.user_status.payed === 1'>已拥有</p>

                            <p class="block-list-item-price" v-else>
                                <span :class = "{
                                    'price-pre': list.coupon_price_format_show,
                                }">{{ list.coupon_price_format_show || list.price_format_show}}</span>
                                <span class = 'block-list-item-price line' v-if="list.coupon_price_format_show"></span>
                                <del class = 'block-list-item-price origin' v-if="list.coupon_price_format_show">{{ list.price_format_show }}</del>
                            </p>
                        </div>
                    </div>
                </div>

                <ul class="block-list-detail">
                    <li class="block-list-detail-item" v-for = '(epItem, epIndex) in list.ep_list' :key = 'epIndex'>
                        <a :href="`${epItem.link}?spm_id_from=${spmidfrom}` | hostAdapt | csourceTransmit" target="_blank" v-href>
                            <BiliImg :src = 'epItem.cover' :width="206" :height="112" cut class = 'block-list-detail-item-lazyImg' />
                        </a>
                        <p class = 'block-list-detail-item-desc'>{{ epItem.title }}</p>
                        <div class = 'block-list-detail-item-label' v-if = 'epItem.pay_status === 1'>试看</div>
                    </li>
                </ul>

        </li>
    </ul>
</template>

<script>
import BiliImg from 'g-public/components/CommonLazyImg';

export default {
    components: {
        BiliImg
    },
    props: {
        resource: {
            type: Array,
            default: () => []
        },
        resourceId: {
            type: String | Number
        },
        spmidfrom: {
            required: true,
            type: String
        }
    },
    data () {
        return {
        };
    },
    created () {
    },
    mounted () {
    },
    methods: {
    }
};
</script>

<style lang="less">
@import url('../styles/list-slider.less');
</style>

<style lang = 'less' scoped>
.block-list-content {
    display: flex;
    transition: all 0.3s ease 0s;

    &.twoRow {
        flex-direction: column;
        flex-wrap: wrap;
        max-height: 440px;

        .block-list-item:nth-child(6n) {
            margin-right: 0;
        }

        .block-list-item:nth-child(n - 6) {
            margin-bottom: 20px !important;
        }
    }
}

.block-list-item-info-player {
    display: flex;
    align-items: center;
}

.block-list-item-info-player--img {
    margin-right: 4px;
    width: 16px;
    height: 16px;
}

.block-list-item {
    /* margin-right: 10px; */
    /* cursor: pointer; */

    &:last-child {
        margin-right: 0;
    }
}

.block-list-item-title {
    /* width: 206px; */
    width: 438px;
    max-height: 42px;
    overflow: hidden;
    font-size: 16px;
    color: #212121;
    font-weight: 500;
    word-break: break-all;

        &:hover {
        color: #0ba395;
    }
}

.block-list-item-desc {
    color: #999;
    line-height: 16px;
    margin: 12px 0 8px;
}

.block-list-item-label {
    position: absolute;
    right: 8px;
    top: 8px;
    z-index: 99;
    text-align: center;
    /* width: 50px; */
    padding: 0 10px;
    height: 22px;
    line-height: 22px;
    color: #fff;
    background: #0BA395;
    border-radius: 2px;
}

.block-list-item-price {
    color: #0BA395;
    line-height: 20px;

    &.line {
         color: #D8D8D8;
    }

    &.buy {
        color: #999999;
    }

    &.origin {
        color: #999999;
    }
}

.block-list-item-info {
    position: absolute;
    width: 100%;
    bottom: 6px;
    left: 0;
    padding: 0 8px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    color: #fff;
}


.block-list-item-box {
   display: flex;
}

.block-list-item-first-content {
    background: rgba(11,163,149,0.05);
    width: 478px;
    padding: 20px;
    box-sizing: border-box;
    position: relative;
}

.block-list-item-playInfo-line {
    color: #d8d8d8;
    margin-right: 10px;
}

.block-list-item-playInfo-first {
    display: flex;
    color: #999;
    margin-top: 12px;
}

.block-list-item-playInfo-first-count {
    margin-right: 10px;
}

.block-list-item-price-first {
    position: absolute;
    left: 20px;
    bottom: 20px;
    /* width: 100%; */
}

.block-list-item-img {
    width: 376px;
    height: 212px;
    position: relative;
    border-radius: 4px;
}

.block-list-detail {
    margin-top: 38px;
    overflow: hidden;
    display: flex;
}

.block-list-detail-item-lazyImg {
    width: 206px;
    height: 112px;
}

.block-list-detail-item-desc {
    font-size: 14px;
    color: #212121;
    line-height: 20px;
    margin-top: 10px;
    width: 206px;
    max-height: 40px;
    overflow: hidden;
    font-weight: 500;
    word-break: break-all;

        &:hover {
        color: #0ba395;
    }
}

.block-list-detail-item {
    margin-right: 10px;
    position: relative;

    &:last-child {
        margin-right: 0;
    }
}

.block-list-detail-item-label {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 40px;
    height: 18px;
    line-height: 18px;
    color: #fff;
    background: #0BA395;;
    text-align: center;
    font-size: 12px;
    border-radius: 2px;
}

.price-pre {
    font-weight: 500;
}


@media screen and (max-width: 1438px) {

    .block-list-item-first-content {
        width: 262px;
    }

    .block-list-item-title {
        width: 206px;
    }

}
</style>